import req from './index'
import local from '@/utils/local'

//获取所有提示数量
export const getAllPromptQuantities = (params) => {
  return req.get('api/admin.php?s=Admin.Cruise.InsCount_Get', params)
}

